import React, { useEffect } from 'react';
import ImageWrapper from '../ImageWrapper';

const ResultCard = ({
    ResultCardName,
    ResultCardDescription,
    ResultCardImgUrl,
}) => {
    return (
        <>
            <div className="result_card_main">
                <ImageWrapper
                    ImgUrl={ResultCardImgUrl}
                    MaxWidth={195}
                    BorderRadius={12}
                    showImage
                />
                <div className="result_card_heading">
                    <h3>{ResultCardName}</h3>
                </div>
                <div className="result_card_subheading">
                    <p>{ResultCardDescription}</p>
                </div>
            </div>
        </>
    );
};

export default ResultCard;
